import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import DialogAddConfig from './DialogAddConfig';
import DialogChangePwdCC from './DialogChangePwdCC';
import DialogConfirm from './DialogConfirm';
import DialogConfirmUpdate from './DialogConfirmUpdate';
import DialogDeleteAvatar from './DialogDeleteAvatar';
import DialogJoinMeetingCC from './DialogJoinMeetingCC';
import DialogReject from './DialogReject';
import DialogEditImages from './DialogeEditImages';
import { DIALOG_ID } from './constant';

// import DialogImportUser from 'pages/manager-users/dialogs/DialogImportUser';
import DialogAddAccountRole from './DialogAddAccountRole';
import DialogCreateOrUpdateRole from './DialogCreateOrUpdateRole';
import DialogEditRoleItem from './DialogEditRoleItem';
import DialogEvent from './DialogEvent';
import DialogExpireService from './DialogExpireService';
import DialogExpiredService from './DialogExpiredService';
import DialogLimitCreate from './DialogLimitCreate';
import DialogLimitAccess from './DialogLitmitAccess';
import DialogProvideService from './DialogProvideService';
import DialoginviteUseSharedStorage from './DialoginviteUseSharedStorage';
import DialogConfirmEncryptedToken from './DialogConfirmEncryptedToken';
import DialogConfirmRefreshToken from './DialogConfirmRefreshToken';
import DialogCreateMCURoom from './DialogCreateMCURoom';
import DialogCreateSipUser from './DialogCreateSipUser';
import DialogCreateOrUpdateMCUDevice from './DialogCreateOrUpdateMCUDevice';
import DialogAddUnit from './DialogAddUnit';

const DialogDisplay = () => {

    const idDialog = useSelector((state) => state.dialog.idDialog);

    return (
        <Fragment>
            <DialogEvent/>
            <DialogConfirm />
            <DialogConfirmEncryptedToken/>
            <DialogEditRoleItem />
            {/* <DialogImportUser /> */}
            <DialogConfirmUpdate />
            <DialogJoinMeetingCC />
            <DialogReject />
            <DialogEditImages />
            <DialogDeleteAvatar />
            <DialogAddConfig />
            <DialogAddUnit/>
            <DialogAddAccountRole />
            <DialogCreateOrUpdateRole/>
            <DialogProvideService />
            <DialogLimitAccess />
            <DialogExpireService />
            <DialogExpiredService/>
            <DialogLimitCreate />
            <DialoginviteUseSharedStorage/>
            {idDialog === DIALOG_ID.CHANGE_PWD && <DialogChangePwdCC />}
            <DialogConfirmRefreshToken />
            <DialogCreateMCURoom/>
            <DialogCreateSipUser/>
            <DialogCreateOrUpdateMCUDevice/>
        </Fragment>
    )
}

export default DialogDisplay
